import { TimelineMax, TweenMax } from 'gsap';
import vhCheck from 'vh-check';
import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
// import 'objectFitPolyfill';
import MicroModal from 'micromodal';

export default {
  init() {
    // JavaScript to be fired on all pages

    // objectFitPolyfill();

    (function () {
      if (typeof NodeList.prototype.forEach === 'function') {
        return false;
      }
      NodeList.prototype.forEach = Array.prototype.forEach;
    })();

    $(window).on('load', function () {
      $(window).scroll();
    });

    vhCheck();

    /*
    * Mobile menu toggle click
    */
    var $menu = $('.overlay-menu'),
      $body = $('body'),
      $menu_button = $('.menu-button'),
      $menu_items = $('.overlay-menu li'),
      $header_logo = $('.header .logo svg path');

      //var $header_links = $('#menu-menuu li a');
      //var $header_links_underline = $('#menu-menuu li.current-menu-item a');


    var freezeVp = function (e) {
      e.preventDefault();
    };

    function stopBodyScrolling(bool) {
      if (bool === true) {
        document.body.addEventListener('touchmove', freezeVp, false);
      } else {
        document.body.removeEventListener('touchmove', freezeVp, false);
      }
    }

    var menuTimeline = new TimelineMax({paused: true, reversed: true});
    menuTimeline.set($menu, {bottom: 0}, 0)
      .to($menu, 0.5, {className: '+=opened', ease: 'Sine.easeInOut'}, 0)
      .to($header_logo, 0.5, {fill: '#F3DEB7'}, 0)
      .staggerFromTo($menu_items, 0.25, {opacity: 0, x: 25}, {opacity: 1, x: 0}, 0.03, 0.5);

    $menu_button.on('click', function () {
      menuTimeline.reversed() ? menuTimeline.play() : menuTimeline.reverse();
      $menu_button.toggleClass('open');

      $body.toggleClass('open');
      $body.hasClass('open') ? stopBodyScrolling(true) : stopBodyScrolling(false);
    });

    /*
    * Background color changes on scroll
    */
    const colors = {
      'green': {
        primary: '#285C61',
        secondary: '#F3DEB7',
      },
      'yellow': {
        primary: '#F3DEB7',
        secondary: '#285C61',
      },
      'white': {
        primary: '#FFFFFF',
        secondary: '',
      },
      'orange': {
        primary: '#E9B89D',
        secondary: '#285C61',
      },
      'swamp': {
        primary: '#717C76',
        secondary: '#E9B89D',
      },
      'swamp-light': {
        primary: '#717C76',
        secondary: '#F3DEB7',
      },
      'gray': {
        primary: '#686869',
        secondary: '#E9B89D',
      },
      'dark-gray': {
        primary: '#464646',
        secondary: '#E9B89D',
      },
      'navy': {
        primary: '#16254C',
        secondary: '#F3DEB7',
      },
      'blue': {
        primary: '#C7CCD3',
        secondary: '#154565',
      },
      'light-blue': {
        primary: '#E5E5E5',
        secondary: '#000000',
      },
      'new-dark-gray': {
        primary: '#464646', //tumehall
        secondary: '#E9B89D',
      },
      'new-light-gray': {
        primary: '#E5E6E6', //helehall
        secondary: '',
      },
      'test': {
        primary: 'red',
        secondary: 'blue', // logo värvina kasutatakse nt
      },
    }

    let headerLastClass = '',
      lastColor = '';
    $(window).scroll(function () {
      // selectors
      let $window = $(window),
        $body = $('body'),
        $section = $('.section'),
        $header = $('.header'),
        $header_logo_paths = $('.header .logo svg path');

      if ($body.hasClass('page-id-24')) {
        return;
      }

      // Change 33% earlier than scroll position so colour is there when you arrive.
      let scroll = $window.scrollTop() + ($window.height() / 1.5);

      $section.each(function () {
        let $this = $(this);

        // if position is within range of this section.
        // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
        // Remember we set the scroll to 33% earlier in scroll var.
        let thisColor = ($(this).data('color')) ? $(this).data('color') : $section.first().data('color');

          let headerClass = 'header--' + thisColor;
          let bodyClass = thisColor;
          let thisBackground = colors[thisColor];

         // console.log(thisColor, 'thisColor--------');


        //KRISTJANI PASK
        //VAIKIMISI VÄÄRTUSED
        /*
        if(
          jQuery( 'body' ).hasClass( 'page-id-26' ) ||   //GALERII
          jQuery( 'body' ).hasClass( 'page-id-28' )      //SISEVIIMISTLUS
        ){
          jQuery('#menu-menuu li a').addClass('text-yellow-overwrite');
          jQuery('#menu-menuu li.current-menu-item a').addClass('before-underline-overwrite-yellow');
          jQuery('.wpml-ls-sub-menu span').addClass('text-yellow');
          jQuery('.language-switcher .wpml-ls-native').addClass('text-yellow');
        }

         */

        //KRISTJANI PASK
        //VAIKIMISI VÄÄRTUSED
        /*
        if(
          jQuery( 'body' ).hasClass( 'page-id-32' )      //ARENDAJAST
        ){
          //jQuery('.square-item__title').removeClass('text-white');
          //jQuery('.square-item__title').addClass('text-white');
          //jQuery('.square-item__button').removeClass('button--yellow');
          //jQuery('.square-item__button').addClass('button--yellow');
        }

        */


        if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
          if (thisBackground && headerClass !== headerLastClass) {

            $header.removeClass(headerLastClass);
            $header.addClass(headerClass);
            $body.addClass(bodyClass);
            $body.removeClass(lastColor);
            headerLastClass = headerClass;
            lastColor = bodyClass;
            TweenMax.to($header, 1, {backgroundColor: thisBackground['primary']});
            TweenMax.to($body, 1, {backgroundColor: thisBackground['primary']});
            TweenMax.to($header_logo_paths, 1, {fill: thisBackground['secondary']});

              //KRISTJANI PASK
              /*if(  jQuery( 'body' ).hasClass( 'page-id-32' ) || jQuery( 'body' ).hasClass( 'page-id-3305' ) || jQuery( 'body' ).hasClass( 'page-id-3361' )){
                TweenMax.to('#menu-menuu li a', 1, {color: thisBackground['secondary']});
                jQuery('#menu-menuu li.current-menu-item a').addClass('before-underline-overwrite-yellow');
                jQuery('.wpml-ls-sub-menu span').addClass('text-yellow');
                jQuery('.language-switcher .wpml-ls-native').addClass('text-yellow');
                //nav hover tuleks lisada
                //keelevaliku ikooni ülekirjutamine tuleks lisada
              }
              */


          }
        }
      });
    }).scroll();

    /*
      Animate function
    */

    function animate(element) {
      const dataset = element.dataset;

      if (!dataset || !element) {
        return false;
      }

      const direction = dataset.direction ? dataset.direction : 'right';
      const duration = dataset.duration ? dataset.duration : 3;
      const distance = dataset.distance ? dataset.distance : 90;
      const scale = dataset.scale ? parseFloat(dataset.scale) : 1;
      const fadeOnly = element.hasAttribute('data-fade-only');
      const hasChildren = element.hasAttribute('data-children');

      const timeline = new TimelineMax();

      if (!hasChildren) {
        if (scale === 1 && !fadeOnly) {
          if (direction === 'top') {
            timeline.fromTo(element, duration, {y: -1 * distance}, {y: 0});
          } else if (direction === 'right') {
            timeline.fromTo(element, duration, {x: distance}, {x: 0});
          } else if (direction === 'bottom') {
            timeline.fromTo(element, duration, {y: distance}, {y: 0});
          } else if (direction === 'left') {
            timeline.fromTo(element, duration, {x: -1 * distance}, {x: 0});
          }
        } else {
          timeline.fromTo(element, duration, {scale: scale}, {scale: 1});
        }

        timeline.fromTo(element, duration / 3, {opacity: 0}, {opacity: 1}, 0);
      } else {
        const elements = element.childNodes;

        if (scale === 1 && !fadeOnly) {
          if (direction === 'top') {
            timeline.staggerFromTo(elements, duration, {y: -1 * distance}, {y: 0}, 0.25);
          } else if (direction === 'right') {
            timeline.staggerFromTo(elements, duration, {x: distance}, {x: 0}, 0.25);
          } else if (direction === 'bottom') {
            timeline.staggerFromTo(elements, duration, {y: distance}, {y: 0}, 0.25);
          } else if (direction === 'left') {
            timeline.staggerFromTo(elements, duration, {x: -1 * distance}, {x: 0}, 0.25);
          }
        } else {
          timeline.staggerFromTo(elements, duration, {scale: scale}, {scale: 1}, 0.25);
        }

        timeline.staggerFromTo(elements, duration / 3, {opacity: 0}, {opacity: 1}, 0.25, 0);
      }

      timeline.set(element, {className: '+=ani-mated'}, 0);

      return timeline;
    }

    const anis = document.querySelectorAll('.ani');
    var controller = new ScrollMagic.Controller();

    var counter = 0;
    anis.forEach((ani) => {
      const currentAni = ani;

      const tweenAni = animate(currentAni);

      if (counter++ === 2) {
        console.log(tweenAni);
      }

      new ScrollMagic.Scene({triggerElement: currentAni, reverse: false, offset: -$(window).height() * 0.4})
        .setTween(tweenAni)
        .addTo(controller);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /*
    *	Popup modal
    */
    const popupFormModal = document.querySelector('.modal--popup-form');

    if (popupFormModal) {
      MicroModal.show('modal-popup-form', {
        awaitCloseAnimation: true,
        disableScroll: true,
        disableFocus: true,
      });

      const popupFormCloseButton = document.querySelector('.modal--popup-form .close-button');
      popupFormCloseButton.addEventListener('click', function () {
        MicroModal.close('modal-popup-form');
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js